import type { OpenAPI } from "simplydo/interfaces";

import type { MappedImpactCategory } from "../types";

type OrganisationImpactsResponse =
  OpenAPI.GET<"/organisations/{id}/impacts">["response"];

export const mapOrganisationImpacts = ({
  impacts,
  impactCategories,
}: OrganisationImpactsResponse): MappedImpactCategory[] =>
  ([{ name: "Default category", order: -1 }] as MappedImpactCategory[])
    .concat(impactCategories)
    .map((category) => ({
      ...category,
      impacts: impacts
        .filter((i) =>
          category._id ? i.category?.id === category._id : !i.category?.id,
        )
        .sort((a, b) => (a.category?.order || 0) - (b.category?.order || 0)),
    }))
    .sort((a, b) => a.order - b.order);
